module.exports = __webpack_public_path__ + "img/www.155d355a.svg";